import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyInputModule } from '@angular/material/legacy-input';

const DEFAULT_MAX_ROWS = 6;
const DEFAULT_MAX_CHARS = 100;

@Component({
  standalone: true,
  selector: 'mode-in-place-textarea',
  imports: [CommonModule, FormsModule, MatLegacyInputModule],
  templateUrl: './in-place-textarea.component.html',
  styleUrls: ['./in-place-textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InPlaceTextareaComponent implements AfterViewInit, OnDestroy {
  @ViewChild('inlineTextareaElement') private inlineTextareaElement: ElementRef | undefined;

  @Input() text = '';
  @Input() maxchars = DEFAULT_MAX_CHARS;
  @Input() maxrows = DEFAULT_MAX_ROWS;
  @Input() placeholder = 'Click to add text';
  @Input() readonly = false;

  @Output() textChange = new EventEmitter<string>();
  @Output() sizeChange = new EventEmitter();

  private resizeObserver: ResizeObserver | undefined;

  ngAfterViewInit(): void {
    this.initWatchers();
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = undefined;
    }
  }

  get placeholderText() {
    return !this.readonly ? this.placeholder : undefined;
  }

  initWatchers() {
    this.resizeObserver = new ResizeObserver(() => {
      this.sizeChange.emit();
    });
    if (this.inlineTextareaElement) {
      this.resizeObserver.observe(this.inlineTextareaElement.nativeElement);
    }
  }

  emitTextChange(): void {
    this.textChange.emit(this.text);
  }

  onEnter($event: KeyboardEvent) {
    if (!$event.shiftKey) {
      ($event.target as HTMLElement)?.blur();
    }
  }
}
